import elementZh from "./element.js";
import customZh from "./custom.js";

// 合并：Element + 你的自定义（完全不冲突）
export default {
  ...elementZh,
  ...customZh,
};
